import { Card, message, Typography } from "antd";

import { FetchError } from "../../../exceptions/AlgoSupervisionExceptions";
import { LinkedInBudgetLevel } from "../../../models/linkedin-manager/strategy/LinkedInBudgetLevel";
import { LinkedInBudgetStrategy } from "../../../models/linkedin-manager/strategy/LinkedInBudgetStrategy";
import { linkedinStrategyManagementService } from "../../../services/linkedin/LinkedInStrategyManagementService";

const { Text } = Typography;

type Props = {
    linkedinBudgetStrategy: LinkedInBudgetStrategy;
    companyId: number | string;
    onDelete: (linkedinBudgetStrategyId: number) => void;
};

function mapBudgetLevelToReadableText(
    budgetLevel: LinkedInBudgetLevel
) {
    switch (budgetLevel) {
        case LinkedInBudgetLevel.LOW:
            return "Low";
        case LinkedInBudgetLevel.MEDIUM:
            return "Medium";
        case LinkedInBudgetLevel.HIGH:
            return "High";
        case LinkedInBudgetLevel.VERY_HIGH:
            return "Very High";
        default:
            throw new Error(
                `Unsupported linkedin budget level ${budgetLevel}`
            );
    }
}

const LinkedInStrategyCard = (props: Props) => {
    const { linkedinBudgetStrategy, companyId, onDelete } = props;

    return (
        <Card
            size="small"
            title={`${mapBudgetLevelToReadableText(
                linkedinBudgetStrategy.budgetLevel
            )} Strategy`}
            bordered={false}
            actions={[
                <div
                    onClick={async () => {
                        try {
                            await linkedinStrategyManagementService.DeleteStrategy(
                                companyId,
                                linkedinBudgetStrategy.id
                            );
                            onDelete(linkedinBudgetStrategy.id);
                            message.success("Deleted strategy successfully");
                        } catch (error) {
                            if (error instanceof FetchError) {
                                message.error(error.apiError.errorMessage);
                            }
                        }
                    }}>
                    Delete
                </div>,
            ]}
            style={{ border: "1px solid #d9d9d9" }}>
            <Text style={{ fontSize: "16px" }}>
                Percent{" "}
                <Text
                    style={{
                        fontSize: "16px",
                    }}
                    strong>
                    {
                        linkedinBudgetStrategy.percentOfStrategies
                    }
                    %
                </Text>
            </Text>
        </Card>
    );
};

export default LinkedInStrategyCard;
